export default __webpack_public_path__ + "static/media/Celebrations3.63ed4985.png";